import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { visibilityOperations } from "../../redux/operations/visibilityOperations";
import { actionsPermissionsOperations } from "../../redux/operations/actionsPermissionsOperations";

const withSideMenuRolesFilter = (WrappedComponent, items) => {
  function SideMenuRoleFilterDecorator(props) {
    const [filtered, setFiltered] = useState([]);

    useEffect(() => {
      props.fetch();
    }, [props.sideMenuItems]);

    const filterByGroup = (s) => {
      if (!s.group) {
        return true;
      }

      if (!!s.action) {
        let name =
          s.group.charAt(0).toLowerCase() + s.group.slice(1) + "_" + s.action;
        // console.log(name);
        if (!!props.actions[name]) {
          return !!props.actions[name].isActive;
        }
        return false;
      } else {
        let name = s.group.charAt(0).toLowerCase() + s.group.slice(1);
        let func = (o) => !!o && !!o.read && o.read.value;
        if (!!s.isVisible) {
          func = eval(s.isVisible);
        }
        let group = !!props.components ? props.components[name] : null;
        // console.log(group);

        if (!!group) {
          return func(group);
        } else {
          return false;
        }
      }
    };

    useEffect(() => {
      let currentFiltered =
        !!items && !!items.items
          ? JSON.parse(JSON.stringify(items.items))
          : null;

      if (Array.isArray(currentFiltered)) {
        currentFiltered = currentFiltered.filter(filterByGroup);

        currentFiltered.forEach((o) => {
          if (Array.isArray(o.items)) {
            o.items = o.items.filter(filterByGroup);
          }
        });
      }
      setFiltered(currentFiltered);
    }, [props.sideMenuItems, props.components, props.actions]);
    return <WrappedComponent {...props} sideMenuItems={{ items: filtered }} />;
  }

  function mapStateToProps(state) {
    return {
      components:
        !!state.visibilityReducer &&
        !!state.visibilityReducer.data &&
        !!state.visibilityReducer.data.crudPermissions
          ? state.visibilityReducer.data.crudPermissions
          : [],
      actions:
        !!state.actionsPermissionsReducer &&
        !!state.actionsPermissionsReducer.data &&
        !!state.actionsPermissionsReducer.data.actionPermissions
          ? state.actionsPermissionsReducer.data.actionPermissions
          : [],
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      fetch: () => {
        dispatch(visibilityOperations.fetch(1));
        dispatch(actionsPermissionsOperations.fetch(1));
      },
    };
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(SideMenuRoleFilterDecorator);
};

export default withSideMenuRolesFilter;
